import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Dashboard from '../views/Dashboard.vue';
import Services from '../views/Services.vue';
import Subscription from '../views/Subscription.vue';
import Billing from '../views/Billing.vue';
import Invoices from '../views/Invoices.vue';
import Payments from '../views/Payment.vue';
import Profile from '../views/Profile.vue';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import Forgot from '../views/Forgot.vue';
import Reset from '@/views/Reset.vue';

const routes = [
    {
        path: "/",
        component: Home,
        name: 'Home',
        meta: { title: "Home Page", requiresAuth: true },
    },
    {
        path: "/dashboard",
        component: Dashboard,
        name: 'Dashboard',
        meta: { title: "Dashboard", requiresAuth: true },
    },
    {
        path: "/services",
        component: Services,
        name: 'Services',
        meta: { title: "Services", requiresAuth: true },
    },
    {
        path: "/subscription",
        component: Subscription,
        name: 'Subscription',
        meta: { title: "Subscription", requiresAuth: true },
    },
    {
        path: "/billing",
        component: Billing,
        name: 'Billing',
        meta: { title: "Billing", requiresAuth: true },
    },
    {
        path: "/invoices",
        component: Invoices,
        name: 'Invoices',
        meta: { title: "Invoices", requiresAuth: true },
    },
    {
        path: "/payments",
        component: Payments,
        name: 'Payments',
        meta: { title: "Payments", requiresAuth: true },
    },
    {
        path: "/profile",
        component: Profile,
        name: 'Profile',
        meta: { title: "Profile", requiresAuth: true },
    },
    {
        path: "/login",
        component: Login,
        name: 'Login',
        meta: { title: "Login" },
    },
    {
        path: "/register",
        component: Register,
        name: 'Register',
        meta: { title: "Register" },
    },
    {
        path: "/forgot",
        component: Forgot,
        name: 'Forgot',
        meta: { title: "Forgot Password" },
    },
    {
        path: '/reset-password/:token',
        component: Reset,
        name: 'Reset',
        meta: { title: "Reset Password" },
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || "SafeWorkPro - Safety that counts - SafeWorkPro";
    //next();

    const isAuthenticated = localStorage.getItem('user'); // Example check for authentication (e.g., using localStorage)

    if (to.matched.some(record => record.meta.requiresAuth) && isAuthenticated == undefined) {
        next({ name: 'Login' });
    } 
    else if (!to.matched.some(record => record.meta.requiresAuth) && isAuthenticated) {
        next({ name: 'Dashboard' });
    }
    else {
        next(); // Proceed to the route if it's not protected
    }
});

export default router;
